<template>
    <v-card tile>
        <v-toolbar
            flat
            dark
            color="primary"
        >
            <v-btn
              icon
              dark
              @click="$emit('fechar')"
            >
                <v-icon class="material-icons">
                    close
                </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-card-text class="headline text-xs-center">
              Selecione um {{ posto ? 'frentista' : 'funcionário' }}
            </v-card-text>
        </v-toolbar>
        <v-container class="pa-4">
            <v-layout v-if="frentistas" align-start justify-start row wrap fill-height>
                    <v-flex xs6 xl3 lg3 sm4 md4 v-for="(item, index) in frentistas" :key="`${index}f`" style="margin-top: 10px;">
                        <v-card class="mx-auto text-center pa-2" color="gray lighten-4" max-width="200" :style="{'border-color': frentistaSelecionado.id_frentista === item.id_frentista? 'rgb(7,77,110)' :'', 'border-style': 'solid'}">
                            <v-img height="170" v-if="item.url_imagem_perfil" :src="item.url_imagem_perfil"/>
                            <v-card v-else color="#DCDCDC" height="170">
                              <v-layout justify-center align-center fill-height>
                                <v-icon x-large>person</v-icon>
                              </v-layout>
                            </v-card>
                            <v-card-text class="text-xs-center">
                                <h3>{{item.nome}}</h3>
                                <h5>Mat: {{item.matricula}}</h5>
                                <v-btn small round block color="primary"
                                @click="openDialog(item)"
                                >
                                    Selecionar
                                </v-btn>
                                <v-btn small round block color="primary"
                                  disabled
                                >
                                    {{item.valor_acumulado}}
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-flex>
            </v-layout>
        </v-container>
    </v-card>

</template>

<script>

export default {
  mounted () {
    if (this.frentistaSelecionado) {
      this.carregarFrentistas()
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    carregarFrentistas () {
      this.$store.dispatch('listarFrentistas')
    },
    openDialog (frentista) {
      this.$store.dispatch('mudarFrentista', frentista)
      this.$emit('fechar')
    }
  }
}
</script>
